import type { SxProps, Theme } from '@mui/material';

export const faceDownDeckTitleSx: SxProps<Theme> = {
  mb: 2,
};

export const faceDownDeckGridSx: SxProps<Theme> = {
  justifyContent: { xs: 'center', sm: 'flex-start' },
};
